import { render, staticRenderFns } from "./AdminProfile.vue?vue&type=template&id=7ac751ba&scoped=true&"
import script from "./AdminProfile.vue?vue&type=script&setup=true&lang=js&"
export * from "./AdminProfile.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac751ba",
  null
  
)

export default component.exports